<template>
  <div style="position:fixed; top:0; left:0; right:0; bottom:0; z-index:50;">
    <div
      class="bg black opacity-50"
      style="position:fixed; top:0; left:0; right:0; bottom:0; z-index:50;"
      @click="close"
    ></div>
    <div
      class="absolute absolute-center bg white shadow-lg p-8"
      style="max-width:95vw; min-width:350px; padding: 2em; z-index:55; border-radius:0.5em;"
    >
      <div
        @click="close"
        class="booking-widget-close bg-black"
      ></div>
      <div>
        <div class="relative pin">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
